import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Col, Form, Input, Row } from 'antd'

const ContactInformationSection = () => {
  const { t } = useTranslation()

  return (
    <div className="contact-info__wrapper">
      <span className="contact-info__title">
        {t('service.addressAndDate.pleaseProvideYourContactInfo')}
      </span>
      <Row gutter={12}>
        <Col lg={12} span={24}>
          <Form.Item
            className="custom-form-item"
            label={t('form.label.contactPersonFirstName')}
            name="contactPersonFirstName"
            rules={[{ required: true }]}
          >
            <Input placeholder={t('form.placeHolder.name')} />
          </Form.Item>
        </Col>
        <Col lg={12} span={24}>
          <Form.Item
            className="custom-form-item"
            label={t('form.label.contactPersonLastName')}
            name="contactPersonLastName"
            rules={[{ required: true }]}
          >
            <Input placeholder={t('form.placeHolder.name')} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        className="custom-form-item"
        label={t('form.label.contactEmail')}
        name="contactEmail"
        rules={[{ required: true }]}
      >
        <Input placeholder={t('form.placeHolder.email')} />
      </Form.Item>
      <Form.Item
        className="custom-form-item"
        label={t('form.label.contactNumber')}
        name="contactNumber"
        rules={[{ required: true }]}
      >
        <Input placeholder={t('form.placeHolder.phoneNumber')} />
      </Form.Item>
    </div>
  )
}

export default ContactInformationSection
